module.exports = __webpack_public_path__ + "img/qr_crew_w.8703dcca.svg";